export const FILE_DOWNLOAD_STARTED = 'FILE_DOWNLOAD_STARTED';
export const FILE_DOWNLOAD_SUCCESS = 'FILE_DOWNLOAD_SUCCESS';
export const FILE_DOWNLOAD_FAILURE = 'FILE_DOWNLOAD_FAILURE';
export const DOWNLOAD_FILES_STARTED = 'DOWNLOAD_FILES_STARTED';
export const DOWNLOAD_FILES_SUCCESS = 'DOWNLOAD_FILES_SUCCESS';
export const DOWNLOAD_FILES_FAILURE = 'DOWNLOAD_FILES_FAILURE';
export const DEFINITIONS_FILES_STARTED = 'DEFINITIONS_FILES_STARTED';
export const DEFINITIONS_FILES_SUCCESS = 'DEFINITIONS_FILES_SUCCESS';
export const DEFINITIONS_FILES_FAILURE = 'DEFINITIONS_FILES_FAILURE';